<template>
  <div>&nbsp;</div>
</template>

<script>
import constants from '@/util/constants'
import { mapActions } from 'vuex'
import util from '@/util'

export default {
  name: 'loginManagerToken',
  mounted () {
    this.executeLogin()
  },
  methods: {
    ...mapActions('auth', ['ActionSetLoginStrategy', 'ActionSetNomeUsuarioLogado', 'ActionSetRegrasLogin', 'ActionSetRepresentanteLegal', 'ActionSetNomeEmpresa', 'ActionSetCpfCnpj', 'ActionSetEmailUsuario', 'ActionSetDadosAlertaVencimento']),

    async executeLogin () {
      let urlHash = window.location.hash
      if (urlHash !== null && urlHash !== undefined && urlHash.length > 0) {
        const indicePontoInterrogacao = urlHash.indexOf('?')
        if (indicePontoInterrogacao === -1) {
          return false
        }
        urlHash = urlHash.substring(indicePontoInterrogacao)
        const urlParams = new URLSearchParams(urlHash)
        let token = urlParams.get('token')
        token = (token === undefined || token === null ? '' : token.trim())

        try {
          await this.gerarCookieTokenCsrf()
          const payload = {
            token: token
          }
          const resposta = await this.axios.post('manager/auth/token', payload)
          const sucesso = resposta.data.success
          if (sucesso === true) {
            this.ActionSetLoginStrategy(resposta.data.login_strategy)
            this.ActionSetRepresentanteLegal(resposta.data.legal_representative)
            this.ActionSetNomeUsuarioLogado(resposta.data.f_user_name)
            this.ActionSetNomeEmpresa(resposta.data.office_name)
            if (!util.valorVazio(resposta.data.cpf_cnpj)) {
              this.ActionSetCpfCnpj(resposta.data.cpf_cnpj)
            } else {
              this.ActionSetCpfCnpj('')
            }
            this.ActionSetEmailUsuario(resposta.data.user_mail)
            this.ActionSetRegrasLogin(JSON.stringify(resposta.data.login_rules))
            this.ActionSetDadosAlertaVencimento(JSON.stringify(resposta.data.dadosAlertaVencimentoDto) ?? null)
            this.$router.push({ name: constants.nomeRotaPendenciasDeLogin })
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    async gerarCookieTokenCsrf () {
      try {
        await this.axios.get('/csrf-token')
      } catch (e) {
        throw e
      }
    }
  }
}
</script>
